module.exports = __webpack_public_path__ + "img/unknown_Tools.dea45c97.svg";